var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid bg-white py-5"},[_c('LoginForm')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row py-3 py-sm-5"},[_c('div',{staticClass:"col-12"},[_c('h1',{staticClass:"text-white text-center"},[_vm._v("\n          Login\n        ")])])])])
}]

export { render, staticRenderFns }